import { endpoints, request } from '../..';

export const tracerServices = {
  trace: ({ loginId, optionId }) =>
    request.post(endpoints.framework('OptionTracking'), {
      'login-id': loginId,
      optionId,
    }),
  updateTraceInfo: ({ trackingId, optionId }) =>
    request.setTracking(trackingId, optionId),
};
